import { useEffect } from "react";
import storeSignupParams from "./storeSignupParams";
import storePartnerParam from "./storePartnerParam";
import storeProductNameParam from "./storeProductNameParam";
import cleanupUrlParams from "./cleanupUrlParams";
import storeUtmParams from "./storeUtmParams";
import storeGroupIdParam from "./storeGroupIdParam";

const Scripts = () => {
  useEffect(() => {
    // Store UTMs but don't remove them from the URL query string
    storeUtmParams();

    // each storage function should return an array of keys it ingested
    const signupKeys = storeSignupParams();
    const partnerKeys = storePartnerParam();
    const productNameKeys = storeProductNameParam();
    const groupIdKeys = storeGroupIdParam();

    // ingested params are removed from the URL query string
    cleanupUrlParams([
      ...signupKeys,
      ...partnerKeys,
      ...productNameKeys,
      ...groupIdKeys,
    ]);
  }, []);

  return null;
};

export default Scripts;
